import mergeWith from 'lodash/mergeWith';
import type { ValidateRowResult } from './useEditableGridLogic';

const concatIfArray = (a: unknown, b: unknown) => {
  if (Array.isArray(a)) {
    return a.concat(b);
  }
};

export const mergeValidationMessages = <TData>(a: ValidateRowResult<TData>, b: ValidateRowResult<TData>) =>
  mergeWith(a, b, concatIfArray);
